import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { CERTIFICATE_LIST } from './roles.model';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { BehaviorSubject } from 'rxjs';
import { CommonService } from 'src/app/shareModule/services/common.service';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
})
export class RolesComponent implements OnInit, OnDestroy {
  private destroy$ = new BehaviorSubject<void>(null);
  constructor(
    private location: Location,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private seoService: SeoService,
    private commonService: CommonService,
    @Inject("WINDOW") private window: any,
  ) { }

  myForm: FormGroup;
  uploadedFile: File | null = null;
  selectedRole: string;
  certificate: any;
  user: any;
  roles: any = CERTIFICATE_LIST;
  role: any;

  goBack() {
    this.commonService.goBack();
  }
  openRoleModal(modal: any, role: any) {
    this.modalService.open(modal, {
      windowClass: 'my-modal sm role-modal',
    });
    this.role = role;

  }
  ngOnInit(): void {
    this.seoService.update({
      title: 'Provide Services and Earn Respect on Kachiing',
      description: 'Wizard Welcome, Provide your services to the community and earn a pay while also gaining the respect and appreciation of your neighbours. Below are a few of the common roles that you can become. - Some roles require certification to be uploaded and verified'
    })
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        this.user = user;
        this.initData(user.id);
      }
    });
    this.roles = this.roles.map((role) => {
      return {
        ...role,
        open: false,
      };
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  initData(id) {
    this.auth.certificateFetch().subscribe((response: any) => {
      this.certificate = response.body.filter((e) => e.appUser.id == id);
      this.roles.map((e) => {
        this.certificate.map((c) => {
          if (e.title == c.role) {
            if (c.status == 0) e.status = 'Pending';
            if (c.status == 1) e.status = 'Certified';
            // if (c.status == 2) e.status = 'Rejected'
          }
        });
      });
    });
  }
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadedFile = input.files[0];
    }
  }

  handleChooseRole(modal: any, role: any) {
    this.myForm = this.fb.group({
      organization: ['', Validators.required],
      certifiedFor: ['', [Validators.required]],
    });

    this.selectedRole = role.title;
    this.modalService.open(modal, {
      size: 'sm',
      // backdrop: 'static',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'forum_form_modal',
    });
  }

  onSubmit(): void {
    if (this.myForm.valid) {
      const formData = new FormData();
      formData.append('organization', this.myForm.value.organization);
      formData.append('certifiedFor', this.myForm.value.certifiedFor);

      if (this.uploadedFile) {
        formData.append('file', this.uploadedFile, this.uploadedFile.name);
      } else {
        this.toastr.error('Please upload a File');
        return;
      }
      formData.append('role', this.selectedRole);

      this.auth.certificateStore(formData).subscribe(
        (response: any) => {
          this.toastr.success(response.body);
          this.initData(this.user.id);
          this.modalService.dismissAll();
        },
        (e) => {
          this.toastr.error('Failed to saving Certificate');
        }
      );
    } else {
    }
  }
}
